var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliaTwist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.1887 30.5673L50.7262 30.3469L50.479 30.797L48.5792 34.2558L48.3385 34.6941L48.7955 34.8971L76.9147 47.3897L77.6719 47.726L77.6719 46.9268L77.6719 43.4679L77.6719 43.1855L77.4082 43.0599L51.1887 30.5673Z",
    fill: "#343333",
    stroke: "#343333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7627 46.0887L48.3044 46.2886L48.5417 46.7287L50.4133 50.1999L50.6568 50.6515L51.1206 50.4348L77.4689 38.1271L77.736 38.0024L77.736 37.7172L77.736 34.2459L77.736 33.4524L76.9826 33.781L48.7627 46.0887Z",
    fill: "#343333",
    stroke: "#343333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9028 30.5673L29.3653 30.3469L29.6125 30.797L31.5122 34.2558L31.753 34.6941L31.296 34.8971L3.17675 47.3897L2.41959 47.726L2.41959 46.9268L2.41959 43.4679L2.41959 43.1855L2.68328 43.0599L28.9028 30.5673Z",
    fill: "#343333",
    stroke: "#343333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3288 46.0887L31.7871 46.2886L31.5498 46.7287L29.6782 50.1999L29.4347 50.6515L28.9708 50.4348L2.62259 38.1271L2.35552 38.0024L2.35552 37.7172L2.35552 34.246L2.35552 33.4524L3.10891 33.781L31.3288 46.0887Z",
    fill: "#343333",
    stroke: "#343333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3062 55.3402C31.8762 55.3402 25 48.5378 25 40.1619C25 31.786 31.8597 25 40.3062 25C48.7527 25 55.6124 31.8024 55.6124 40.1783C55.6124 48.5542 48.7527 55.3566 40.3062 55.3566V55.3402Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.95 40.1619C24.95 48.5493 31.8219 55.3633 40.2562 55.3901V55.4066H40.3062C48.7799 55.4066 55.6624 48.5822 55.6624 40.1783C55.6624 31.7744 48.7799 24.95 40.3062 24.95C31.8325 24.95 24.95 31.7579 24.95 40.1619ZM25.8599 40.1783C25.8599 32.2729 32.3332 25.8532 40.3062 25.8532C48.2627 25.8532 54.7524 32.273 54.7524 40.1783C54.7524 48.0837 48.2792 54.5034 40.3062 54.5034C32.3332 54.5034 25.8599 48.0837 25.8599 40.1783Z",
    fill: "#343333",
    stroke: "#343333",
    strokeWidth: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5544 29.9993H30.058V50.3245H50.5544V29.9993Z",
    stroke: "#343333",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2915 25.7905L25.7983 40.1626L40.2915 54.5346L54.7846 40.1626L40.2915 25.7905Z",
    stroke: "#343333",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliaTwist);
export default __webpack_public_path__ + "static/media/DeliaTwist.be3a970f7f3245f81e16d2377edf1b44.svg";
export { ForwardRef as ReactComponent };